import { useQuery } from "@tanstack/react-query";
import { getDepartments } from "../../api/apiDepartments";
import i18next from "i18next";

/**
 * Hook لجلب قائمة الأقسام
 * @param {Object} params - Query parameters (page, per_page, search, is_active)
 */
export function useGetDepartments(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["departments", params, i18next.language],
        queryFn: () => getDepartments(params),
        retry: false,
    });

    const departments = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, departments, meta, refetch };
}
